
export function remove(a: any[], el: any) {
  const idx = a.indexOf(el);
  if (idx >= 0) {
    // console.log("array.remove: removed at idx", idx, el);
    a.splice(idx, 1);
    return;
  }
  // console.log("array.remove: didn't remove", el, a);
}

export function pushUnique(a: any[], el: any) {
  if (a.includes(el)) {
    return;
  }
  a.push(el);
}
